import styled from 'styled-components';

const EmailCell = styled.div`
  text-transform: lowercase;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default EmailCell;
